import axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";

import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { GET_CORRESPONDENTS_API } from "./constants";
import queryKeys from "./queryKeys";

export interface Correspondents {
  code: string;
  name: string;
  businessLines: string[];
}

export function useGetCorrespondents(
  options?: UseQueryOptions<Correspondents[], any>
) {
  const getCorrespondentsApi = `${getAppConfigSetting(
    "apiUrl"
  )}${GET_CORRESPONDENTS_API}`;

  const getCorrespondents = async () => {
    const { data } = await axios.get(getCorrespondentsApi, {
      withCredentials: true,
    });
    return data;
  };

  return useQuery<Correspondents[], AxiosError>(
    [queryKeys.getCorrespondentsList],
    getCorrespondents,
    {
      cacheTime: 60 * 60 * 1000 * 24, // 24hrs
      staleTime: 60 * 60 * 1000 * 24, // 24hrs
      ...options,
    }
  );
}
